import type { APIWithPagination, DeepQueryParams } from '@gik/core/api/BaseAPIConfig';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import type { SWRConfiguration } from 'swr';
import type { RelationFilter } from './PostsUrlBuilder';
import PostsUrlBuilder from './PostsUrlBuilder';

const path = 'posts';

export interface PostsRelatedParams extends APIWithPagination {
  relationFilters: RelationFilter<string[]>[];
  perPage?: number;
}

export function getParams(params: PostsRelatedParams): DeepQueryParams {
  // prettier-ignore
  return new PostsUrlBuilder()
  .withPerPage(params.perPage)
  .withMultipleTaxonomiesMultipleItems(params.relationFilters)
  .orderedByPriority()
    .params;
}

// TODO: replace with new related posts plugin (use situation, tag, article type as taxonomies)
export function usePostsRelated(params: PostsRelatedParams, config?: SWRConfiguration) {
  const hasTaxonomyAndTerms =
    Array.isArray(params?.relationFilters) &&
    params?.relationFilters?.length > 0 &&
    params?.relationFilters?.every?.(rf => rf.taxonomy && rf.terms);
  // important if there is no slug the path should be null so nothing will be fetched
  return useWPApi<WordpressPost[]>(
    params?.relationFilters && hasTaxonomyAndTerms ? path : null,
    params?.relationFilters && getParams(params),
    config
  );
}
